import React from 'react';

import SelectionField from '../SelectionField';

const TableDropdownSelectionField = ({

  disabled,

  fieldId,
  fieldIdentifier,
  fieldPositionId,

  column,
  rowIndex,

  displayType,
  targetValue,

  cellValue, //Individual cell value
  value, //Rows

  onChange,
  onFocus,

  //Styles
  primaryColor,
  fontColor,
  borderWidth,
  borderColor,
  borderRadius,
  backgroundColor,
  margin,

  rowId,
  columnIdentifier,

}) => {

  const handleCellChange = () => {

    const nextValue = [...value];
    const nextRow = { ...nextValue[rowIndex] };
    nextRow.cells = { ...nextRow.cells };

    /**
     * If cell already has targetValue set then we remove it (toggle the value).
     * If cell doesn't have targetValue set then we add it.
     */
    nextRow.cells[column] = nextRow.cells[column] === targetValue ? '' : targetValue;

    nextValue[rowIndex] = nextRow;

    if (!disabled && onFocus) onFocus(fieldId, fieldIdentifier, fieldPositionId, { }, rowId, column, columnIdentifier);
    if (onChange) onChange(fieldId, fieldIdentifier, fieldPositionId, nextValue);

  };

  return (
    <SelectionField
      {...{

        id: fieldPositionId,
        value: cellValue === targetValue,
        disabled,
        displayType,
        onChange: handleCellChange,

        //Styles
        primaryColor,
        fontColor,
        borderColor,
        borderRadius,
        borderWidth,
        backgroundColor,
        margin

      }}
    />
  );

};

export default TableDropdownSelectionField;
